import avitoIcon from '@iconify-icons/arcticons/avito'
import maxIcon from '@iconify-icons/arcticons/max-messenger'
import telegramIcon from '@iconify-icons/arcticons/telegram'
import vkIcon from '@iconify-icons/arcticons/vk'
import alertCircleIcon from '@iconify-icons/hugeicons/alert-circle'
import arrowLeftIcon from '@iconify-icons/hugeicons/arrow-left-01'
import attachmentIcon from '@iconify-icons/hugeicons/attachment-01'
import bubbleChatUserIcon from '@iconify-icons/hugeicons/bubble-chat-user'
import checkmarkCircleIcon from '@iconify-icons/hugeicons/checkmark-circle-01'
import clockIcon from '@iconify-icons/hugeicons/clock-01'
import contactBookIcon from '@iconify-icons/hugeicons/contact-book'
import checkListIcon from '@iconify-icons/hugeicons/check-list'
import filterRemoveIcon from '@iconify-icons/hugeicons/filter-remove'
import helpCircleIcon from '@iconify-icons/hugeicons/help-circle'
import inboxIcon from '@iconify-icons/hugeicons/inbox'
import inboxUnreadIcon from '@iconify-icons/hugeicons/inbox-unread'
import mailOpenIcon from '@iconify-icons/hugeicons/mail-open-02'
import messageBlockedIcon from '@iconify-icons/hugeicons/message-blocked'
import messageReplyIcon from '@iconify-icons/hugeicons/message-circle-reply'
import messageMultipleIcon from '@iconify-icons/hugeicons/message-multiple-02'
import moreIcon from '@iconify-icons/hugeicons/more-horizontal'
import templateIcon from '@iconify-icons/hugeicons/notepad-text'
import promotionIcon from '@iconify-icons/hugeicons/promotion'
import refreshIcon from '@iconify-icons/hugeicons/refresh-01'
import searchIcon from '@iconify-icons/hugeicons/search-01'
import sendIcon from '@iconify-icons/hugeicons/send'
import studentIcon from '@iconify-icons/hugeicons/student'
import tickDoubleIcon from '@iconify-icons/hugeicons/tick-double-01'
import userAddIcon from '@iconify-icons/hugeicons/user-add-01'
import userAccountIcon from '@iconify-icons/hugeicons/user-account'
import { Icon, type IconifyIcon } from '@iconify/vue/offline'
import { defineComponent, h } from 'vue'

function iconComponent(name: string, icon: IconifyIcon) {
  return defineComponent({
    name,
    setup() {
      return () => h(Icon, {
        'aria-hidden': 'true',
        height: '1em',
        icon,
        width: '1em',
      })
    },
  })
}

/** Arcticons use a 48px grid with a 1px stroke; 3px matches Hugeicons at 24/1.5. */
function normalizeBrandStroke(icon: IconifyIcon): IconifyIcon {
  return {
    ...icon,
    body: `<g stroke-width="3">${icon.body}</g>`,
  }
}

/**
 * Communication-specific aliases for Vuetify. Each icon is bundled as local SVG
 * data, so rendering never depends on the Iconify API or another CDN.
 */
export const communicationIconAliases = {
  avoAttachment: iconComponent('AvoAttachmentIcon', attachmentIcon),
  avoBack: iconComponent('AvoBackIcon', arrowLeftIcon),
  avoChannelAvito: iconComponent('AvoChannelAvitoIcon', normalizeBrandStroke(avitoIcon)),
  avoChannelMax: iconComponent('AvoChannelMaxIcon', normalizeBrandStroke(maxIcon)),
  avoChannelTelegram: iconComponent('AvoChannelTelegramIcon', normalizeBrandStroke(telegramIcon)),
  avoChannelVk: iconComponent('AvoChannelVkIcon', normalizeBrandStroke(vkIcon)),
  avoCommunicationGroup: iconComponent('AvoCommunicationGroupIcon', messageMultipleIcon),
  avoCommunicationInbox: iconComponent('AvoCommunicationInboxIcon', inboxUnreadIcon),
  avoCommunicationPortal: iconComponent('AvoCommunicationPortalIcon', bubbleChatUserIcon),
  avoCampaigns: iconComponent('AvoCampaignsIcon', promotionIcon),
  avoContacts: iconComponent('AvoContactsIcon', contactBookIcon),
  avoDelivered: iconComponent('AvoDeliveredIcon', tickDoubleIcon),
  avoFailed: iconComponent('AvoFailedIcon', alertCircleIcon),
  avoFilterEmpty: iconComponent('AvoFilterEmptyIcon', filterRemoveIcon),
  avoInbox: iconComponent('AvoInboxIcon', inboxIcon),
  avoMarkRead: iconComponent('AvoMarkReadIcon', mailOpenIcon),
  avoMessageBlocked: iconComponent('AvoMessageBlockedIcon', messageBlockedIcon),
  avoMessagePending: iconComponent('AvoMessagePendingIcon', clockIcon),
  avoMessageUnknown: iconComponent('AvoMessageUnknownIcon', helpCircleIcon),
  avoMore: iconComponent('AvoMoreIcon', moreIcon),
  avoRefresh: iconComponent('AvoRefreshIcon', refreshIcon),
  avoReply: iconComponent('AvoReplyIcon', messageReplyIcon),
  avoSearch: iconComponent('AvoSearchIcon', searchIcon),
  avoSend: iconComponent('AvoSendIcon', sendIcon),
  avoSent: iconComponent('AvoSentIcon', checkmarkCircleIcon),
  avoStudent: iconComponent('AvoStudentIcon', studentIcon),
  avoStudentAdd: iconComponent('AvoStudentAddIcon', userAddIcon),
  avoStudentCard: iconComponent('AvoStudentCardIcon', userAccountIcon),
  avoStudentTasks: iconComponent('AvoStudentTasksIcon', checkListIcon),
  avoTemplates: iconComponent('AvoTemplatesIcon', templateIcon),
} as const
